export default function useEnv(key){

   // Prefix your key with VITE_ because Vite env vars must start with that
  const fullKey = `VITE_${key}`;

  // Access value from import.meta.env dynamically
  const value = import.meta.env[fullKey];

  return value;
}